import React from 'react'
import styles from './styles.module.scss'
import Icon from 'srcReact/components/icons/Icon'

function CardSubTitle({ title, greyTitle, className, titleStyle }) {
  return (
    title && (
      <div className={`${styles.header} ${className}`}>
        {title && <h3 className={`${styles.title} ${greyTitle ? styles.greyTitle : ''} ${titleStyle}`}>{title}</h3>}
      </div>
    )
  )
}

export default CardSubTitle
